import * as TYPES from './actions/types';
import { mapThreads, mapMessages } from './secure-message-mapper';

export const LOCAL_STORAGE_KEY = 'patient:secure-message';

export const initialState = {
  legalMessage: null,
  recipient: null,
  threads: [],
  messages: [],
  filter: 'Current',
  isReplyItemVisible: false,
  selectedThreadIndex: null,
  isListView: true,
  unreadCount: null,
};

export const secureMessageReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.SECURE_MESSAGE_LEGAL_HEADER_LOADED:
      newState = { ...state, legalMessage: action.legalMessage };
      break;
    case TYPES.SECURE_MESSAGES_THREADS_LOADED:
      newState = { ...state, threads: mapThreads(action.threads, action.language, action.timeZoneOffset) };
      break;
    case TYPES.SECURE_MESSAGES_THREAD_LOAD_SUCCESS:
      newState = { ...state, messages: mapMessages(action.messages, action.language, action.timeZoneOffset) };
      break;
    case TYPES.SECURE_MESSAGES_TOGGLE_FILTER_PANEL:
      newState = { ...state, filter: action.filter || state.filter };
      break;
    case TYPES.SHOW_SECURE_MESSAGE_REPLY_ITEM:
      newState = { ...state, isReplyItemVisible: action.isVisible };
      break;
    case TYPES.SECURE_MESSAGE_THREAD_THREAD_SELECTED:
      newState = { ...state, selectedThreadIndex: action.threadId };
      break;
    case TYPES.SECURE_MESSAGE_ARCHIVE_THREAD_SELECTED:
      newState = { ...state, selectedArchivedThreadIndex: action.threadId };
      break;
    case TYPES.SECURE_MESSAGE_THREAD_CLEAR:
      newState = { ...state, messages: [] };
      break;
    case TYPES.SHOW_SECURE_MESSAGE_LIST_VIEW:
      newState = { ...state, isListView: action.isListView };
      break;
    case TYPES.SECURE_MESSAGES_UNREAD_COUNT_LOADED:
      newState = { ...state, unreadCount: action.unreadCount };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default secureMessageReducer;
